import { render, staticRenderFns } from "./AnswerDialog.vue?vue&type=template&id=886aa3ea"
import script from "./AnswerDialog.vue?vue&type=script&lang=js"
export * from "./AnswerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports